<template>
  <div>
    <div
      class="contentStyleBody"
    >
      <div
        v-for="(item, index) in pricingManage"
        :key="index"
      >
        <div
          class="contentStyleBodyEl"
        >
          <div class="rightContent">
            <div class="rightContentBorder" />
            <div
              class="d-flex align-center mLeft"
              @click="showData(item.managedName)"
            >
              <v-icon
                v-if="show[getKey(item.managedName)]"
                large
                color="primary"
              >
                mdi-menu-down
              </v-icon>
              <v-icon
                v-else
                large
                color="primary"
              >
                mdi-menu-right
              </v-icon>
            </div>
            <div class="pricingPeriod">
              {{ $t(`aquassistBilling.pricingManagement.labels.${item.managedName}`) }}
              <div
                v-if="item.color"
                class="pricingPeriodPoint"
              />
            </div>
          </div>
        </div>
        <div v-if="show[getKey(item.managedName)]">
          <PriceDetails
            :pricingPeriod="items.id"
            :listManage="item.managedList"
            :managedName="item.managedName"
            :isModeEdit="modeEdit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PriceDetails from '@/views/admin/aquassistBilling/pricingManagementDetails/PriceDetails.vue';

export default {
    name: 'AquassistManage',
    components: { PriceDetails },
    props: {
        items: {
            type: Object,
            default: () => {},
        },
        modeEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            pricingManage: [],
            show: {},
        };
    },
    created() {
        this.initPricingManage();
    },
    methods: {
        initPricingManage() {
            this.pricingManage = [
                { managedList: [...this.items.users], managedName: 'users' },
                { managedList: [...this.items.sites], managedName: 'sites' },
                { managedList: [...this.items.features], managedName: 'features' },
            ];
        },
        showData(name) {
            const key = this.getKey(name);
            this.show = {
                ...this.show,
                [key]: !this.show[key],
            };
        },
        getKey(name) {
            return `${name}_${this.items.id}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/pricingManagement.scss";
</style>
